import {Component, HostListener} from '@angular/core';
import {LayoutService} from '../../../../core/services/layout.service';
import {AsyncPipe, CommonModule, NgClass} from "@angular/common";
import {Observable} from "rxjs";
import {Router} from '@angular/router';

@Component({
  selector: 'app-header',
  imports: [
    AsyncPipe,
    NgClass,
    CommonModule
  ],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss',
})
export class AppHeaderComponent {

  isMobileOpen$!: Observable<boolean>;
  isProfileOpen = false;

  userName = '';
  userType = '';
  phoneNumber = '';

  constructor(public layoutService: LayoutService,private router: Router) {
    // ✅ Safe: constructor runs AFTER dependency injection
    this.isMobileOpen$ = this.layoutService.isMobileOpen$;
    const userData = localStorage.getItem('user');

    if (userData) {

      const user = JSON.parse(userData);

      this.userName = user.userName || '';
      this.userType = user.userType || '';
      this.phoneNumber = user.phoneNumber || '';

    }
  }

  toggleSidebar() {
    if (window.innerWidth < 1200) {
      this.layoutService.toggleMobileOpen();
    } else {
      this.layoutService.toggleExpanded();
    }
  }


  toggleProfileDropdown(): void {
    this.isProfileOpen = !this.isProfileOpen;
  }

  logout(): void {

    localStorage.removeItem('AuthHeader');
    localStorage.removeItem('user');

    localStorage.clear();

    this.router.navigateByUrl('/login');

  }

  // 👇 Close dropdown on outside click
  @HostListener('document:click', ['$event'])
  closeOnOutsideClick(event: Event): void {
    const target = event.target as HTMLElement;

    if (!target.closest('.position-relative')) {
      this.isProfileOpen = false;
    }
  }

}
